import Subpage from './Subpage';

export default Subpage;
